
import { Component, Vue, Prop} from 'vue-property-decorator';
import CaringChildrenSurvey from "./CaringChildrenSurvey.vue";

import PageBase from "../../PageBase.vue";
import { stepInfoType, stepResultInfoType } from "@/types/Application";

import { namespace } from "vuex-class";   
import "@/store/modules/application";
import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';
const applicationState = namespace("Application");

@Component({
    components:{
      CaringChildrenSurvey,
      PageBase
    }
})
export default class caringForChildGa extends Vue {

    @Prop({required: true})
    step!: stepInfoType

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;  

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    dataReady = false;
    currentStep =0;
    currentPage =0;
    showTable = true;  
    childData = [];
    anyRowToBeEdited = null;
    editId = null; 
    incompleteError =  false;   

    careDetails = "";
    parentOtherChild = 'n';

    childWording = 'child';
    updated = 0;

    mounted(){
        Vue.nextTick(()=>this.surveyHasError());        
        this.reloadPageInformation();        
    }  

    public reloadPageInformation() {

        this.updated = 0;

        this.dataReady = false;  

        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage; 
        
        if (this.step.result?.caringForChildGaSurvey?.data) {

            const caringInfo = this.step.result.caringForChildGaSurvey.data;
            this.childData = caringInfo.childInfo?caringInfo.childInfo:[];
            this.careDetails = caringInfo.caringForChildGa?.careDetails?caringInfo.caringForChildGa.careDetails:'';
            this.parentOtherChild = caringInfo.caringForChildGa?.parentOtherChild?caringInfo.caringForChildGa.parentOtherChild:'n';
            
        }

        if (this.step.result?.childrenDetailsGaSurvey) {
            const childData = this.step.result.childrenDetailsGaSurvey.data;            
            if (childData?.length>1){
                this.childWording = "children";                    
            } else {
                this.childWording = "child";
            }
        }

        this.dataReady = true;
        
    }

    public situationChanged(){
        this.updated++;        
    }
    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
         Vue.nextTick(()=>{
            const el = document.getElementById('caring-child-info-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public childComponentData(value) {       
        this.showTable = value;
    }

    public populateSurveyData(childValue) {

        const currentIndexValue = this.childData?.length > 0 ? this.childData[this.childData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newChild = { ...childValue, id };
        this.childData = [...this.childData, newChild];

        this.showTable = true; 
        this.resetChildrenRelatedPages(this.childData);
    }

    public deleteRow(rowToBeDeleted) {
       
        this.childData = this.childData.filter(data => {
            return data.id !== rowToBeDeleted;
        }); 
        this.resetChildrenRelatedPages(this.childData);
        this.surveyHasError();
    }

    public editRow(editedRow) {
        this.childData = this.childData.map(data => {
            return data.id === this.editId ? editedRow : data;
        });
        this.showTable = true;
        this.surveyHasError();
        this.resetChildrenRelatedPages(this.childData);
    }

    public onPrev() {
       Vue.prototype.$UpdateGotoPrevStepPage();
    }

    public onNext() {
       //TODO: check completion
       Vue.prototype.$UpdateGotoNextStepPage()
       
    }

    public getChildrenResults(){
        const questionResults: {name: string; value: any; title: string; inputType: string}[] =[];
        questionResults.push({name:'careDetails', value: this.careDetails, title:'How will you care for the cild(ren)?', inputType:''})
        questionResults.push({name:'parentOtherChild', value: this.parentOtherChild == 'y'?'Yes':'No', title:'Are you the parent, stepparent or guardian of another child?', inputType:''})
        
        if(this.parentOtherChild == 'y'){
            for(const child of this.childData)
            {
                questionResults.push({name:'childInfoSurvey', value: this.getChildInfo(child), title:'Child '+child.id +' Information', inputType:''})
            }
        }        
        
        return {
            data: {
                childInfo: this.childData, 
                caringForChildGa: 
                {
                    careDetails: this.careDetails,
                    parentOtherChild: this.parentOtherChild
                }
            },
            questions:questionResults, pageName:'Children Information', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getChildInfo(child){
        const resultString = [];

        resultString.push(Vue.filter('styleTitle')("Name: ")+Vue.filter('getFullName')(child.name));
        resultString.push(Vue.filter('styleTitle')("Birthdate: ")+Vue.filter('beautify-date')(child.dob))        
        resultString.push(Vue.filter('styleTitle')("Your relationship: ")+child.relation)             
        
        return resultString
    }

    public resetChildrenRelatedPages(childData?) {
    
        const p = this.stPgNo.GA;

        const pages = [
            p.ReviewYourAnswersGA
        ]
        Vue.filter('setProgressForPages')(p._StepNo, pages,50);    

    }

    public surveyHasError(){
        let progress = (this.careDetails.length == 0 ||(this.parentOtherChild == 'y' && this.childData?.length == 0))? 50 : 100;
        this.incompleteError =  false;        
        for(const child of this.childData){
            if (!child.name || 
                !child.dob || !child.relation){            
                this.incompleteError = true;  
                progress = 50;    
                break
            }
        }        
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }

    public isDisableNext() {
        return (this.careDetails.length == 0 || (this.parentOtherChild == 'y' && this.childData?.length == 0));
    }


    beforeDestroy() {
        this.surveyHasError();        
        this.UpdateStepResultData({step:this.step, data: {caringForChildGaSurvey: this.getChildrenResults()}})       
    }
}
